import React, { Fragment } from 'react';
import { Alert, Row, Col } from 'antd';
import { v4 as uuid } from 'uuid';
import { APP_ENV } from '../../app/const/environments';

const ApolloError = ( { graphQLErrors, networkError, message, extraInfo } ) => {
        
    const networkErrorMessage = networkError?.message || false;
    
    return (
        <Row className='apollo-error'>
            <Col span={ 24 }>
                {
                    graphQLErrors &&
                    graphQLErrors.length > 0 &&
                    graphQLErrors.map( ( { message, extensions }, i ) => {
                        return <Alert
                            key={ uuid() }
                            message="Error:"
                            description={ message }
                            type="error"
                            closable
                            showIcon
                        />;
                    } )
                }
                {
                    networkErrorMessage && 
                        <Alert
                            message="Network Error"
                            description={ `${ networkErrorMessage } Please contact support if you need further assistance.` }
                            type="error"
                            closable
                            showIcon
                        /> 
                }
                {
                    networkError &&
                    Array.isArray( networkError ) === false &&
                    Array.isArray( networkError.result?.errors ) &&
                    (
                        APP_ENV.toUpperCase() === 'PROD' ?
                            <Alert
                                message="Network Error"
                                description={ `${ networkError.name } (${ networkError.statusCode }): please contact support if you need further assistance.` }
                                type="error"
                                closable
                                showIcon
                            /> :
                            <Fragment>
                                {
                                    networkError.result.errors.map( ( err, i ) => {
                                        return <Alert
                                            key={ i }
                                            message="Network Error"
                                            description={ err.message }
                                            type="error"
                                            closable
                                            showIcon
                                        />;
                                    } )
                                }
                            </Fragment>
                    )
                }
                <br />
            </Col>
        </Row>
    );
};

export default ApolloError;
